import { Injectable, OnDestroy, signal } from '@angular/core';
import type * as L from 'leaflet';

@Injectable()
export class StadiaMapsMarkerService implements OnDestroy {
  private readonly markerRef = signal<L.Marker | null>(null);

  registerMarker(marker: L.Marker) {
    this.markerRef.set(marker);
  }
  getMarker() {
    return this.markerRef();
  }

  ngOnDestroy(): void {
    this.markerRef.set(null);
  }
}
